import React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import dataelements from './Data';


export default function Timelines(){
    return (
      <div className='time'>
        {dataelements.map((d,i) => (
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2,
              },
            }}
          >
            
            <TimelineItem>
              <TimelineOppositeContent color="textSecondary" className='year'>
              {d.year}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot variant="outlined" />
                {i < 2 ?<TimelineConnector /> : console.log("So another developer eh?")}
              </TimelineSeparator>
              <TimelineContent>
              <div class="card mb-3 border-light" key = {i}>
                <div class="card-body text-secondary">
                  <h5 class="card-title">{d.school}</h5>
                  <p class="card-text">{d.course}<br></br>{d.score}</p>
                </div>
              </div>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        ))}
      </div>
    );
}